import(/* webpackMode: "eager" */ "/vercel/path0/src/app/ios/page.tsx");
